import axios from "axios";
import consts from "../consts";
import { setError, setErroAPI, setSuccess } from "../common/toast/toast";
import { initialize } from "redux-form";
import confirmDialog from "../common/dialog/confirmDialog";
import { setArquivoPDF } from "../displayPDF/displayPDFActions";
import FormatUtils from "../common/formatUtils/FormatUtils";
import JSZip from "jszip";
import { base64ToBlob } from "../utils/base64ToBlob";

import { saveAs } from "file-saver";
import { combinarPdfRetornarUrl } from "../utils/combinarPdfRetornarUrl";
import sleep from "../utils/sleep";

export function setModoTela(modo, registro = {}) {
    return {
        type: "FATURA_MODO_TELA",
        payload: {
            modo: modo,
            registro: registro,
        },
    };
}
export function initForm(registro = {}) {
    return [initialize("faturaForm", registro)];
}

export function setFiltro(filtro) {
    return {
        type: "FATURA_FILTRO",
        payload: filtro,
    };
}

export function setAguardando(aguardando) {
    return {
        type: "FATURA_SET_AGUARDANDO",
        payload: aguardando,
    };
}

export function resetListaFaturasAgua() {
    return {
        type: "FATURA_AGUA_LISTADO",
        payload: [],
    };
}

function filtrarIdsUnidadesConsumidoras(state) {
    //se selecionou alguma UC manda a lista de ids das UCs selecionadas
    let ids_unidades_consumidoras_agua = state.filtro.unidades_consumidoras.map((item) => item.value);
    if (ids_unidades_consumidoras_agua.length) {
        return ids_unidades_consumidoras_agua;
    }

    //se não tiver nenhuma UC selecionada, filtra a lista de UC original de acordo com os filtros selecionados
    const listaFiltrada = state.listaUnidadeConsumidoraAgua.filter((item) => !state.filtro.id_cliente || item.id_cliente == state.filtro.id_cliente).map((item) => item.id);

    return listaFiltrada.length ? listaFiltrada : [0];
}

export function setImportacaoValidada(registro) {
    return (dispatch, getState) => {
        if (!registro.importacao_validada && !window.confirm("Deseja realmente reabrir a fatura?")) return {};

        if ((registro.erros || []).length > 0 && !registro.observacao && registro.importacao_validada) {
            setError("Informe a observação da importação");
            return {};
        }

        axios
            .put(`${consts.API_URL}/fatura-agua/status-importacao`, {
                id: registro.id,
                observacao: registro.observacao,
                importacao_validada: registro.importacao_validada,
            })
            .then((resp) => {
                setSuccess("Operação Realizada com sucesso.");
                dispatch(getListaFaturasAdm());
                dispatch(
                    initForm({
                        ...registro,
                        importacao_validada: registro.importacao_validada,
                    })
                );
            })
            .catch((e) => {
                setErroAPI(e);
            });
    };
}

export function getListaClientesUcsFiltradosSelect(config = {}) {
    return async (dispatch, getState) => {
        const usuarioLogado = getState().auth.usuarioLogado;
        const listaConcessionariaAgua = getState().fatura.listaConcessionariaAgua;
        const listaClienteAgua = getState().fatura.listaClienteAgua;
        const listaUnidadeConsumidoraAgua = getState().fatura.listaUnidadeConsumidoraAgua;
        const listasJaCarregadas = listaConcessionariaAgua.length && listaClienteAgua.length && listaUnidadeConsumidoraAgua.length;
        if (!config.force && (!usuarioLogado || listasJaCarregadas)) return {};

        try {
            await Promise.all([dispatch(getListaConcessionaria()), dispatch(getListaCliente()), dispatch(getListaUnidadeConsumidora())]);
        } catch (erro) {
            setErroAPI(erro);
        }
    };
}

// export function getLista(config = {}) {
//     return async (dispatch, getState) => {
//         const usuarioLogado = getState().auth.usuarioLogado;
//         const filtroAtual = getState().fatura.filtro;
//         const ultimoFiltroUtilizado = getState().fatura.ultimoFiltroUtilizadoAgua;
//         const listaTemFaturas = getState().fatura.listaAgua.length;
//         const filtroIgualAnterior = JSON.stringify(filtroAtual) === JSON.stringify(ultimoFiltroUtilizado);

//         //se forçar atualizar no config, vai fazer o fetch obrigatoriamente, pq deve ter editado algum registro e precisa atualizar
//         if (!config.forcarBusca && listaTemFaturas && (!usuarioLogado || filtroIgualAnterior)) return {};

//         dispatch(setAguardando(true));

//         try {
//             // console.log("BUSCANDO................");
//             dispatch({
//                 type: "FATURA_AGUA_LISTADO",
//                 payload: [],
//             });
//             await dispatch(getListaClientesUcsFiltradosSelect());

//             const filtroIdCliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : getState().fatura.filtro.id_cliente;
//             const filtroUCMultiplo = filtrarIdsUnidadesConsumidoras(getState().fatura);

//             const filtroAno = getState().fatura.filtro.ano;
//             const filtroMes = getState().fatura.filtro.mes;

//             const resposta = await axios.get(
//                 `${consts.API_URL}/fatura-agua?id_usuario_logado=${usuarioLogado.id}&id_cliente=${filtroIdCliente}&ids_unidades_consumidoras_agua=${encodeURIComponent(
//                     filtroUCMultiplo
//                 )}&ano=${filtroAno}&mes=${filtroMes}`
//             );

//             //ja filtra só faturas em que o usuário logado é implantador, pelo backend
//             const listaFaturas = resposta.data || [];

//             dispatch({
//                 type: "FATURA_AGUA_ULTIMO_FILTRO_UTILIZADO",
//                 payload: getState().fatura.filtro,
//             });

//             dispatch({
//                 type: "FATURA_AGUA_LISTADO",
//                 payload: listaFaturas,
//             });
//         } catch (erro) {
//             console.log(erro);
//             setErroAPI(erro);
//         } finally {
//             dispatch(setAguardando(false));
//         }
//     };
// }

export function getListaFaturasAdm({ forcarBusca } = {}) {
    return async (dispatch, getState) => {
        const usuarioLogado = getState().auth.usuarioLogado;
        const filtroAtual = getState().fatura.filtro;
        const listaTemFaturas = getState().fatura.listaAgua.length;
        const ultimoFiltroUtilizado = getState().fatura.ultimoFiltroUtilizadoAgua;
        const filtroIgualAnterior = JSON.stringify(filtroAtual) === JSON.stringify(ultimoFiltroUtilizado);

        if (!forcarBusca && (!usuarioLogado || (listaTemFaturas && filtroIgualAnterior))) return {};

        dispatch(setAguardando(true));

        try {
            dispatch({
                type: "FATURA_AGUA_LISTADO",
                payload: [],
            });
            await dispatch(getListaClientesUcsFiltradosSelect());

            const idEmpresaDashboard = getState().dashboard.filtro.id_empresa;
            const idEmpresa = usuarioLogado.id_empresa || idEmpresaDashboard;

            const filtroIdCliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : getState().fatura.filtro.id_cliente;
            const filtroUCMultiplo = filtrarIdsUnidadesConsumidoras(getState().fatura);
            const filtroAno = getState().fatura.filtro.ano;
            const filtroMes = getState().fatura.filtro.mes;

            const resposta = await axios.get(
                `${consts.API_URL}/fatura-agua-adm?id_usuario_logado=${usuarioLogado.id}&id_cliente=${filtroIdCliente}&ids_unidades_consumidoras_agua=${encodeURIComponent(
                    filtroUCMultiplo
                )}&ano=${filtroAno}&mes=${filtroMes}&id_empresa=${idEmpresa}`
            );

            //ja filtra só faturas em que o usuário logado é implantador, pelo backend
            const listaFaturas = resposta.data || [];

            dispatch({
                type: "FATURA_AGUA_ULTIMO_FILTRO_UTILIZADO",
                payload: getState().fatura.filtro,
            });

            dispatch({
                type: "FATURA_AGUA_LISTADO",
                payload: listaFaturas,
            });
        } catch (erro) {
            console.log(erro);
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function getListaFaturasCliente({ forcarBusca } = {}) {
    return async (dispatch, getState) => {
        const usuarioLogado = getState().auth.usuarioLogado;
        const filtroAtual = getState().fatura.filtro;
        const listaTemFaturas = getState().fatura.listaAgua.length;
        const ultimoFiltroUtilizado = getState().fatura.ultimoFiltroUtilizadoAgua;
        const filtroIgualAnterior = JSON.stringify(filtroAtual) === JSON.stringify(ultimoFiltroUtilizado);

        if (!forcarBusca && (!usuarioLogado || (listaTemFaturas && filtroIgualAnterior))) return {};

        dispatch(setAguardando(true));

        try {
            dispatch({
                type: "FATURA_AGUA_LISTADO",
                payload: [],
            });
            await dispatch(getListaClientesUcsFiltradosSelect());

            const idEmpresaDashboard = getState().dashboard.filtro.id_empresa;
            const idEmpresa = usuarioLogado.id_empresa || idEmpresaDashboard;

            const filtroIdCliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : getState().fatura.filtro.id_cliente;
            const filtroUCMultiplo = filtrarIdsUnidadesConsumidoras(getState().fatura);
            const filtroAno = getState().fatura.filtro.ano;
            const filtroMes = getState().fatura.filtro.mes;

            const resposta = await axios.get(
                `${consts.API_URL}/fatura-agua-cliente?id_usuario_logado=${usuarioLogado.id}&id_cliente=${filtroIdCliente}&ids_unidades_consumidoras_agua=${encodeURIComponent(
                    filtroUCMultiplo
                )}&ano=${filtroAno}&mes=${filtroMes}&id_empresa=${idEmpresa}`
            );

            //ja filtra só faturas em que o usuário logado é implantador, pelo backend
            const listaFaturas = resposta.data || [];

            dispatch({
                type: "FATURA_AGUA_ULTIMO_FILTRO_UTILIZADO",
                payload: getState().fatura.filtro,
            });

            dispatch({
                type: "FATURA_AGUA_LISTADO",
                payload: listaFaturas,
            });
        } catch (erro) {
            console.log(erro);
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function buscarPdf(id, nomePdf, confirmacao = false) {
    return async (dispatch, getState) => {
        if (confirmacao && !window.confirm("Deseja abrir a fatura em pdf")) return {};
        try {
            const resp = await axios.get(`${consts.API_URL}/fatura-agua/buscar-pdf?id=${id}`);
            if (resp.data && resp.data.arquivo_pdf) {
                dispatch(setArquivoPDF(resp.data.arquivo_pdf, nomePdf, "portrait", id));
            }
        } catch (ex) {
            setErroAPI(ex);
        }
    };
}

export async function incluirDownloadRealizado(id_faturas = []) {
    return async (dispatch, getState) => {
        try {
            const id_usuario = parseInt((getState().auth.usuarioLogado || {}).id);
            if (!id_usuario || !id_faturas.length || id_faturas.find((id) => isNaN(parseInt(id)))) {
                throw new Error('Não foi possível alterar a situação da fatura para "Donwload Realizado"');
            }
            dispatch(setAguardando(true));
            await axios.put(`${consts.API_URL}/fatura-agua/incluir-download-realizado`, { id_faturas, id_usuario });
            setSuccess("Download realizado");
            await dispatch(getListaFaturasCliente({ forcarBusca: true }));
        } catch (error) {
            setErroAPI(error);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export async function excluirDownloadRealizado(idFatura) {
    return async (dispatch, getState) => {
        try {
            const id_usuario = parseInt((getState().auth.usuarioLogado || {}).id);
            const id_fatura = parseInt(idFatura);
            if (!id_usuario || !id_fatura) {
                throw new Error('Não foi possível alterar a situação da fatura para "Donwload Pendente"');
            }
            dispatch(setAguardando(true));
            if (!window.confirm('Deseja realmente definir a fatura como "Download Pendente"')) return {};
            await axios.put(`${consts.API_URL}/fatura-agua/excluir-download-realizado`, { id_fatura, id_usuario });
            setSuccess('Situação da fatura alterada para "Download Pendente"');
            await dispatch(getListaFaturasCliente({ forcarBusca: true }));
        } catch (error) {
            setErroAPI(error);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function salvar(registro) {
    return (dispatch, getState) => {
        const compSplited = (registro.competencia || "").split("/");
        const competencia =
            compSplited[0] && (compSplited[0].match(/\d+/g) || []).join("").trim().length == 2 && compSplited[1] && (compSplited[1].match(/\d+/g) || []).join("").trim().length == 4
                ? `${compSplited[1]}${compSplited[0]}`
                : null;

        if (!registro.id) {
            dispatch(setAguardando(true));

            axios
                .post(`${consts.API_URL}/fatura-agua`, {
                    ...registro,
                    competencia,
                })
                .then((resp) => {
                    setSuccess("Operação Realizada com sucesso.");
                    dispatch(getListaFaturasAdm({ forcarBusca: true }));
                    dispatch(
                        initForm({
                            ...registro,
                            ...resp.data,
                            competencia: registro.competencia,
                        })
                    );
                    dispatch(setModoTela(getState().fatura.modoTela, { ...getState().fatura.registro, ...resp.data }));
                    dispatch(setAguardando(false));
                })
                .catch((e) => {
                    setErroAPI(e);
                    dispatch(setAguardando(false));
                });
        } else {
            confirmDialog("Deseja realmente alterar?", () => {
                dispatch(setAguardando(true));

                axios
                    .put(`${consts.API_URL}/fatura-agua`, {
                        ...registro,
                        competencia,
                        valor_fatura: parseFloat(String(registro.valor_fatura).replace(",", ".")) || 0,
                        quantidade_agua_consumida: parseFloat(String(registro.quantidade_agua_consumida).replace(",", ".")) || 0,
                    })
                    .then((resp) => {
                        setSuccess("Operação Realizada com sucesso.");
                        dispatch(getListaFaturasAdm({ forcarBusca: true }));
                        dispatch(setModoTela("lista"));
                        dispatch(setAguardando(false));
                    })
                    .catch((e) => {
                        setErroAPI(e);
                        dispatch(setAguardando(false));
                    });
            });
        }
    };
}

//CHAMAR A ACTION NO BOTAO [$] e configurar rota no backend
//para atualizar a data de pagamento para o dia atual
export function setDataPagamento(fatura) {
    const { id, dados_fatura, ...registro } = fatura;

    return (dispatch, getState) => {
        const modoExclusao = getState().fatura.modoTela === "excluirDataPagamento";
        if (modoExclusao && window.confirm("Se remover a data de pagamento a fatura vai retornar o status para não pago. Deseja realmente alterar o status de pagamento?")) {
            registro.data_pagamento = null;
            registro.comprovantes_pagamento = null;

            axios
                .put(`${consts.API_URL}/fatura-agua/definir-data-pagamento${fatura.id ? `?id=${id}` : ""}`, registro)
                .then((resp) => {
                    setSuccess("Operação Realizada com sucesso.");
                    dispatch(getListaFaturasCliente({ forcarBusca: true }));
                    dispatch(setModoTela("lista"));
                })
                .catch((e) => {
                    setErroAPI(e);
                });
        }
        if (!modoExclusao) {
            axios
                .put(`${consts.API_URL}/fatura-agua/definir-data-pagamento${fatura.id ? `?id=${id}` : ""}`, registro)
                .then((resp) => {
                    setSuccess("Operação Realizada com sucesso.");
                    dispatch(getListaFaturasCliente({ forcarBusca: true }));
                    dispatch(setModoTela("lista"));
                })
                .catch((e) => {
                    setErroAPI(e);
                });
        }
    };
}

export function setAlertaVerificado(fatura) {
    const { id } = fatura;

    return (dispatch, getState) => {
        if (!window.confirm('Deseja realmente marcar o alerta como "Revisado"?')) return {};
        axios
            .put(`${consts.API_URL}/fatura-agua/definir-alerta-verificado${id ? `?id=${id}` : ""}`)
            .then((resp) => {
                setSuccess("Operação Realizada com sucesso.");
                dispatch(getListaFaturasAdm({ forcarBusca: true }));
                dispatch(setModoTela("lista"));
            })
            .catch((e) => {
                setErroAPI(e);
            });
    };
}

//retorna a cor da data de vencimento na tela de listagem de faturas do cliente
// export function getCorDataVencimentoFatura(fatura, usuarioLogado) {
//     const foiImportada = fatura.arquivo_pdf && (!(fatura.erros || []).length || fatura.importacao_validada);
//     //se o cliente não controla vencimento deixa todas brancas
//     if ((usuarioLogado.acesso_cliente && !fatura.controla_vencimento_fatura) || (!foiImportada && !fatura.data_pagamento)) {
//         return { backgroundColorTr: "rgb(255, 255, 255)", backgroundColorTd: "rgb(245, 245, 245)", cor: "BRANCA" };
//     }
//     //se estiver paga retorna verde
//     if (fatura.data_pagamento) return { backgroundColorTr: "rgb(221, 255, 221)", backgroundColorTd: "rgb(68, 255, 170)", cor: "VERDE" };
//     if (!fatura.data_vencimento)
//         return {
//             backgroundColorTr: "rgb(243 255 255)",
//             backgroundColorTd: "rgb(197 255 255)",
//             cor: "AZUL",
//         };

//     if (fatura.data_vencimento) {
//         const doisDiasMs = 1000 * 60 * 60 * 24 * 2;
//         const dataVencimentoMs = new Date(fatura.data_vencimento).getTime();
//         const data2DiasParaVencimentoMs = new Date(dataVencimentoMs - doisDiasMs).getTime();
//         const dataAtual = new Date();
//         dataAtual.setHours(0, 0, 0, 0);
//         const dataAtualMs = dataAtual.getTime();

//         //cinza se faltar 3 dias ou mais para o vencimento
//         //OU SE NÃO ESTIVER PAGA MAS TIVER A COMPETÊNCIA ANTERIOR A DATA DE IMPLANTAÇÃO DA ROTINA
//         // if (dataAtualMs < data2DiasParaVencimentoMs)
//         if (dataAtualMs < data2DiasParaVencimentoMs || fatura.competencia <= 202501)
//             return {
//                 backgroundColorTr: "rgb(243 255 255)",
//                 backgroundColorTd: "rgb(197 255 255)",
//                 cor: "AZUL",
//             };

//         //amarela quando falta 2 ou 1 dia para o vencimento
//         if (dataAtualMs >= data2DiasParaVencimentoMs && dataAtualMs < dataVencimentoMs)
//             return {
//                 backgroundColorTr: "rgb(255 255 212)",
//                 backgroundColorTd: "rgb(255 239 113)",
//                 cor: "AMARELA",
//             };

//         //vermelha se esta no dia do vencimento ou se já está vencida
//         if (dataAtualMs >= dataVencimentoMs)
//             return {
//                 backgroundColorTr: "rgb(251 202 202)",
//                 backgroundColorTd: "rgb(255 101 105)",
//                 cor: "VERMELHA",
//             };
//     }
// }

export function excluir(registro) {
    return (dispatch) => {
        confirmDialog("Deseja realmente excluir?", () => {
            axios
                .delete(`${consts.API_URL}/fatura-agua?id=${registro.id}`)
                .then((resp) => {
                    setSuccess("Operação Realizada com sucesso.");
                    dispatch(getListaFaturasAdm({ forcarBusca: true }));
                    dispatch(setModoTela("lista"));
                })
                .catch((e) => {
                    setErroAPI(e);
                });
        });
    };
}

export function getListaCliente() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            const idEmpresaDashboard = getState().dashboard.filtro.id_empresa;
            const idEmpresa = usuarioLogado.id_empresa || idEmpresaDashboard;

            const request = await axios.get(`${consts.API_URL}/cliente-agua/listar-select?id_usuario_logado=${usuarioLogado.id}&id_empresa=${idEmpresa}`);
            dispatch({
                type: "FATURA_AGUA_CLIENTE_SELECT_LISTADO",
                payload: request,
            });
        } catch (error) {
            setErroAPI(error);
        }
    };
}

export function getListaUnidadeConsumidora() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            const idEmpresaDashboard = getState().dashboard.filtro.id_empresa;
            const idEmpresa = usuarioLogado.id_empresa || idEmpresaDashboard;

            const request = await axios.get(`${consts.API_URL}/unidade-consumidora-agua/listar-select?id_usuario_logado=${usuarioLogado.id}&id_empresa=${idEmpresa}`);
            dispatch({
                type: "FATURA_AGUA_UNIDADE_CONSUMIDORA_SELECT_LISTADO",
                payload: request,
            });
        } catch (e) {
            setErroAPI(e);
        }
    };
}

export function getListaConcessionaria() {
    return async (dispatch, getState) => {
        try {
            const request = await axios.get(`${consts.API_URL}/concessionaria-agua/listar-select`);
            dispatch({
                type: "FATURA_CONCESSIONARIA_AGUA_SELECT_LISTADO",
                payload: request,
            });
        } catch (e) {
            setErroAPI(e);
        }
    };
}

export async function gerarRelatorio({ html, landscape, scale }) {
    return async (dispatch, getState) => {
        try {
            dispatch(setAguardando(true));
            const response = await axios.post(`${consts.API_URL}/relatorio`, { html, landscape, scale }, { responseType: "blob" });

            const reader = new FileReader();

            reader.onloadend = () => {
                const pdfBase64 = reader.result;
                dispatch(setArquivoPDF(pdfBase64, "Relatório.pdf", landscape ? "landscape" : "portrait"));
                dispatch(setAguardando(false));
            };

            reader.onerror = () => {
                console.error("Erro ao ler blob para base64");
                dispatch(setAguardando(false));
                setError("Erro ao processar o relatório");
            };

            reader.readAsDataURL(response.data);
        } catch (erro) {
            console.log(erro);
            dispatch(setAguardando(false)); // <<< chama aqui no catch também
            setError("Erro ao gerar o relatório");
        }
    };
}

export function getComprovantePagamento(anexo) {
    return async (dispatch, getState) => {
        const usuarioLogado = getState().auth.usuarioLogado;

        if (!usuarioLogado || !anexo) {
            setError("Solicitação inválida");
            return {};
        }

        const respostaToken = await axios.get(`${consts.API_URL}/token`);
        const token = respostaToken.data;
        const url = `${consts.FILE_URL}/anexo?nome_arquivo=${encodeURIComponent(anexo)}&download=${true}&token=${token}`;

        // ✅ download direto, compatível com iPhone/Safari
        window.location.href = url;
    };
}

export function reprocessar(id) {
    return async (dispatch, getState) => {
        const idUsuarioLogado = getState().auth.usuarioLogado.id;
        if (!idUsuarioLogado) return {};

        if (!window.confirm("Deseja realmente reprocessar?")) return;
        dispatch(setAguardando(true));
        try {
            await axios.post(`${consts.API_URL}/fatura-agua/reprocessar`, { id, id_usuario_importacao_fatura: idUsuarioLogado });
            setSuccess("Operação Realizada com sucesso.");
        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(getListaFaturasAdm({ forcarBusca: true }));
            dispatch(setModoTela("lista"));
            dispatch(setAguardando(false));
        }
    };
}

export function reprocessarTodas(lista) {
    return async (dispatch, getState) => {
        try {
            const idUsuarioLogado = getState().auth.usuarioLogado.id;
            if (!idUsuarioLogado || !lista.length) return {};

            let listaFiltrata = [...lista];
            const existeFaturaImportacaoValidada = lista.find((fatura) => fatura.importacao_validada);
            if (existeFaturaImportacaoValidada && !window.confirm(`Deseja reprocessar também as faturas com importação validada?`)) {
                listaFiltrata = lista.filter((fatura) => !fatura.importacao_validada); //separa somente as com erro de importação
            }
            if (!window.confirm(`Deseja realmente reprocessar as ${listaFiltrata.length} fatura${listaFiltrata.length == 1 ? "" : "s"}?`)) return {};

            dispatch(setAguardando(true));
            for (const item of listaFiltrata) {
                await axios.post(`${consts.API_URL}/fatura-agua/reprocessar`, { id: item.id, id_usuario_importacao_fatura: idUsuarioLogado });
            }
            setSuccess("Operação Finalizada.");
        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(getListaFaturasAdm({ forcarBusca: true }));
            dispatch(setAguardando(false));
        }
    };
}

export function importar(id_fatura, base64, callback) {
    return async (dispatch, getState) => {
        const idUsuarioLogado = getState().auth.usuarioLogado.id;
        if (!idUsuarioLogado) return {};

        if (!window.confirm("Deseja realmente importar o arquivo PDF selecionado?")) return {};
        try {
            dispatch(setAguardando(true));
            const resposta = await axios.post(`${consts.API_URL}/fatura-agua/importar`, {
                id_fatura: id_fatura,
                base64: base64,
                id_usuario_importacao_fatura: idUsuarioLogado,
            });
            const faturaAtualizada = resposta.data[0];

            setSuccess("Operação Realizada com sucesso.");
            dispatch(
                initForm({
                    ...faturaAtualizada,
                    competencia: `${String(faturaAtualizada.competencia).substring(4, 6)}/${String(faturaAtualizada.competencia).substring(0, 4)}`,
                    valor_fatura: FormatUtils.formatarValorTela(faturaAtualizada.valor_fatura, 2),
                    quantidade_agua_consumida: FormatUtils.formatarValorTela(faturaAtualizada.quantidade_agua_consumida, 2),
                })
            );
            if (callback) callback();
        } catch (e) {
            setErroAPI(e);
        } finally {
            dispatch(getListaFaturasAdm({ forcarBusca: true }));
            dispatch(setAguardando(false));
        }
    };
}

export function baixarMultiplasFaturasPdf(listaFaturas) {
    return async (dispatch, getState) => {
        try {
            const ano = "_" + String(getState().fatura.filtro.ano).substring(2);
            const mes = getState().fatura.filtro.mes ? "_" + String(getState().fatura.filtro.mes) : "";
            const usuarioLogado = getState().auth.usuarioLogado;
            //seleciona apenas as faturas que possuem arquivo pdf e que forem do cliente logado ou se for um admin
            const faturasComPdf = listaFaturas.filter((item) => item.arquivo_pdf && (usuarioLogado.id_cliente == item.id_cliente || usuarioLogado.administrador));
            if (!faturasComPdf.length) {
                setError("Nenhuma fatura com PDF na lista");
                return {};
            }
            const faturaSemPdf = listaFaturas
                .filter((item) => !item.arquivo_pdf && (usuarioLogado.id_cliente == item.id_cliente || usuarioLogado.administrador))
                .map((item) => " " + item.nome_unidade_consumidora);
            if (
                faturaSemPdf.length &&
                !window.confirm(`Existem faturas ainda não disponíveis pela concessionária de água nessa lista: ${faturaSemPdf}. Deseja continuar mesmo assim?`)
            ) {
                return {};
            } else if (
                !window.confirm(
                    "Essa ação pode levar alguns minutos, e após concluída será necessário descompactar o arquivo baixado para acessar todos os PDFs, deseja continuar?"
                )
            ) {
                return {};
            }
            dispatch(setAguardando(true));
            const ids = faturasComPdf.map((item) => item.id);
            const idsComNomeArquivo = faturasComPdf.map((item) => {
                return {
                    id: item.id,
                    nome_arquivo: `Fatura_UC-${item.nome_unidade_consumidora.split("-")[0].trim()}_${String(item.competencia).substring(4, 6)}-${String(item.competencia).substring(
                        0,
                        4
                    )}.pdf`,
                };
            });

            const resp = await axios.get(`${consts.API_URL}/fatura-agua/buscar-multiplas-faturas-pdf?ids=${encodeURIComponent(ids)}`);
            // //console.log(resp.data);

            // Array de arquivos PDF em formato Base64
            const pdfBase64ArrayComId = resp.data;

            // Crie uma nova instância de JSZip
            const zip = new JSZip();

            // Função para baixar múltiplos PDFs em formato Base64
            pdfBase64ArrayComId.forEach((item) => {
                const { id, arquivo_pdf } = item;
                // Converta o Base64 para um blob
                const pdfBlob = base64ToBlob(arquivo_pdf);
                const objArquivo = idsComNomeArquivo.find((elemento) => elemento.id == id);
                if (objArquivo) {
                    const nomeArquivo = objArquivo.nome_arquivo;
                    // Adicione o blob ao ZIP com um nome de arquivo específico
                    zip.file(nomeArquivo, pdfBlob);
                }
            });
            // Gere o conteúdo do ZIP como um blob
            const zipBlob = await zip.generateAsync({ type: "blob" });

            // Salve o arquivo ZIP usando file-saver
            saveAs(zipBlob, `faturas${mes}${ano}.zip`);
            await dispatch(incluirDownloadRealizado(ids));
        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}
export function imprimirMultiplasFaturas(listaFaturas) {
    return async (dispatch, getState) => {
        try {
            if (!window.confirm("Essa ação pode demorar, dependendo da quantidade de faturas, deseja continuar?")) {
                return {};
            }
            const usuarioLogado = getState().auth.usuarioLogado;
            //seleciona apenas as faturas que possuem arquivo pdf e que forem do cliente logado ou se for um admin
            const faturasComPdf = listaFaturas.filter((item) => item.arquivo_pdf && (usuarioLogado.id_cliente == item.id_cliente || usuarioLogado.administrador));
            if (!faturasComPdf.length) {
                setError("Nenhuma fatura com PDF na lista");
                return {};
            }
            const faturasSemPdf = listaFaturas.filter((item) => !item.arquivo_pdf).map((item) => " " + item.nome_unidade_consumidora);
            if (
                faturasSemPdf.length &&
                !window.confirm(`Existem faturas ainda não disponíveis pela concessionária de água nessa lista: ${faturasSemPdf}. Deseja continuar mesmo assim?`)
            ) {
                return {};
            }
            dispatch(setAguardando(true));
            const ids = faturasComPdf.map((item) => item.id);
            const resp = await axios.get(`${consts.API_URL}/fatura-agua/buscar-multiplas-faturas-pdf?ids=${encodeURIComponent(ids)}`);
            // Array de arquivos PDF em formato Base64
            const listaPdfBase64 = resp.data.map((item) => item.arquivo_pdf);
            const pdfUrl = await combinarPdfRetornarUrl(listaPdfBase64);
            // Abre o URL do PDF combinado em uma nova janela para impressão
            const printWindow = window.open(pdfUrl, "_blank");

            while (!printWindow) {
                await sleep(1000);
            }
            printWindow.focus();
            printWindow.print();
            // Fechar a janela após a impressão
            printWindow.onafterprint = () => {
                printWindow.close();
                URL.revokeObjectURL(pdfUrl); // Liberar o URL de objeto
            };
        } catch (erro) {
            // console.log(erro);
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}
